export const LOGIN_USER  = 'LOGIN_USER'
export const LOGIN_FAIL  = 'LOGIN_FAIL'
export const LOGOUT_USER  = 'LOGOUT_USER'